//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true,
      default: null,
    },
    webp: {
      type: String,
      default: null,
    },
    lqip: {
      type: String,
      // src ne doit pas être vide pour ne pas que l'image webp soit téléchargée 2 fois => lqip doit toujours avoir une valeur par défaut (1x1 px transparent)
      default:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
    },
    imgClass: {
      type: String,
      default: "",
    },
    imgStyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    imgClassList() {
      return `lazyLoad ${this.isLoading ? "isLoading" : "isLoaded"} ${
        this.imgClass
      }`;
    },
  },
  watch: {
    src(val) {
      this.$nextTick(() => {
        this.LazyLoad();
      });
    },
  },
  mounted() {
    this.$refs.img.addEventListener("load", this.onImgLoad);
  },

  beforeDestroy() {
    this.$refs.img.removeEventListener("load", this.onImgLoad);
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    LazyLoad() {
      this.isLoading = true;
      const media =
        this.$refs.picture.parentNode.querySelectorAll("[data-lazy]");
      [...media].forEach((m) => this.$lazyLoad(m));
    },
    onImgLoad(event) {
      if (this.$refs.img.dataset.src) {
        return;
      }
      this.isLoading = false;
    },
  },
};
